import { render, staticRenderFns } from "./Recommand.vue?vue&type=template&id=26af6e08&scoped=true"
import script from "./Recommand.vue?vue&type=script&lang=js"
export * from "./Recommand.vue?vue&type=script&lang=js"
import style0 from "./Recommand.vue?vue&type=style&index=0&id=26af6e08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26af6e08",
  null
  
)

export default component.exports